import { IconArrowNarrowRight } from '@tabler/icons-react'

import Text from 'components/ui/text'
import { cn } from 'utils/classMerge'
import { translate } from 'utils/translation'

import SoFi from '../assets/sofi.png'
import Adobe from '../assets/adobe.png'
import Cnn from '../assets/cnn.png'
import LinkedIn from '../assets/linkedin.png'
import Intuit from '../assets/intuit.png'

interface CustomersSectionProps {
  className?: string
}

export const CustomersSection = ({ className }: CustomersSectionProps) => {
  return (
    <div
      className={cn(
        className,
        'tw-mt-auto tw-flex tw-flex-col tw-items-center tw-gap-6 tw-rounded-lg tw-bg-orange-50 tw-p-4 md:tw-px-12 md:tw-py-4',
      )}
    >
      <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 md:tw-flex-row md:tw-gap-4">
        <Text
          className="tw-m-0 tw-text-center tw-text-sm tw-font-medium tw-text-zinc-950 md:tw-text-left"
          boldClassName="tw-text-orange-500"
        >
          join_over_x_companies
        </Text>
        <a
          href="https://npdigital.com"
          className="tw-group tw-relative tw-flex tw-shrink-0 tw-items-center tw-gap-1 tw-text-sm tw-font-medium tw-text-orange-500 md:tw-text-base"
          target="_blank"
          rel="noreferrer"
        >
          {translate('visit_website')}
          <IconArrowNarrowRight className="tw-size-4 tw-shrink-0 md:tw-size-5" />
          <span className="tw-absolute tw-bottom-0 tw-left-0 tw-h-[1px] tw-w-full tw-bg-orange-500 tw-opacity-25" />
        </a>
      </div>

      <div className="tw-flex tw-w-full tw-flex-wrap tw-items-center tw-justify-center tw-gap-6 md:tw-justify-between">
        <img src={SoFi} alt="SoFi" className="tw-h-3 tw-w-auto" />
        <img src={Adobe} alt="Adobe" className="tw-h-3 tw-w-auto" />
        <img src={Cnn} alt="CNN" className="tw-h-4 tw-w-auto" />
        <img src={LinkedIn} alt="LinkedIn" className="tw-h-3 tw-w-auto" />
        <img src={Intuit} alt="Intuit" className="tw-h-3 tw-w-auto" />
      </div>
    </div>
  )
}
